export enum FieldTypeEnum {
    Dropdown = 1,
    Inputs = 2,
    Calendar = 3,
    Switch = 4,
    RadioBtn = 5,
    InputNumber = 6,
    InputDecimalNumber = 7,
    CalendarTime = 8
}
